import React from 'react'
import styled from 'styled-components'
import P from '../../commons/P'
import Bold from "../../commons/Bold";

const LinkToTrasparenza = () => {

  return (
    <Container>
      <StyledP>
          DISCLAIMER** I finanziamenti proposti nell’ambito del servizio PrestitoPuoi sono <Bold>erogati da istituti e intermediari finanziari partner. </Bold>
         Banca Sistema <Bold>non eroga direttamente il finanziamento,</Bold> ma opera come intermediario nell’ambito del servizio PrestitoPuoi.
      </StyledP>
    </Container>
  )
}

export default LinkToTrasparenza

// region Style
const Container = styled.div`
  margin: 0 auto 10rem auto;
  max-width: 1095px;
`
const StyledP = styled(P)`
  text-align: left;
  font-style: italic;`
// endregion
